import { getSearchParam } from "@/utils";

export const useBeforeUnload = () => {
  window.addEventListener("beforeunload", () => {
    const keyId = getSearchParam("keyId");
    const keyDid = getSearchParam("keyDid");
    if (keyId && !keyDid) {
      LocalStorage.removeItem("KEY_DID");
    }
  });
};
